// React
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
// Stores
import LoggedUserStore from 'stores/LoggedUserStore';
// Material components
import { withStyles } from '@mui/styles';
// Routes
import routes from 'routes/routes';
// PCP Components
import LinkIcon from 'components/papers/LinkIcon';
//Styles
import styles from 'components/page/DashboardPage/DashboardPage.style';

class Dashboard extends React.Component {

    state = {
        rights: LoggedUserStore.getCurrentRights()
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    updateRights = (rights) => {
        this.setState({
            rights,
        });
    };

    isAuthorized = (routeName) => {
        if (!routeName || this.state.rights.includes(routeName.toUpperCase()) === true)
            return true;
        return false;
    };

    componentDidMount() {
        LoggedUserStore.addChangeListener(this.onLoggedUserStoreChange);
        this.mounted = true;
    }

    componentWillUnmount() {
        LoggedUserStore.removeChangeListener(this.onLoggedUserStoreChange);
        this.mounted = false;
    }

    onLoggedUserStoreChange = () => {
        if (!this.mounted) {
            return false;
        }
        this.updateRights(LoggedUserStore.getCurrentRights());
    };

    render() {
        const { classes } = this.props;

        if (!LoggedUserStore.isLogged()) {
            return (
                <Redirect to='/login'/>
            );
        }
        return (
            <div className={classes.root}>
                <div className={classes.tabListBigDiv}>
                    <div className={classes.tabListContainer}>
                        <div className={classes.tabLine} elevation={1}>
                            {routes.map((input, key) => {
                                if (input.sidebarName && input.dashboardIcon && this.isAuthorized(input.rightName) === true) {
                                    return (
                                        <LinkIcon
                                            key = {key}
                                            icon = {input}
                                            time = {key}
                                        />
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(Dashboard);
